import { createWebSocketRequest } from './utils';

/**
 * Fetch trading history
 * @param {Object} options - Optional parameters
 * @param {number} options.limit - Maximum number of history items to return
 * @param {string} options.startDate - Start date for history filter (ISO format)
 * @param {string} options.endDate - End date for history filter (ISO format)
 * @param {number} options.page - Page number for pagination
 * @returns {Promise<Object>} Promise resolving to the history data with pagination
 */
export const getHistory = (options = {}) => {
  const { limit = 50, startDate, endDate, page = 1 } = options;
  
  return createWebSocketRequest({
    eventName: 'get-history-response',
    requestType: 'get-history',
    requestData: {
      limit,
      startDate,
      endDate,
      page
    },
    dataValidator: (data) => {
      if (!data || !data.data) {
        throw new Error('Invalid history data format');
      }
      
      // Return structured response with history items and pagination
      return {
        history: data.data || [],
        pagination: data.pagination || { total: 0, page, limit, pages: 0 },
        message: data.message || '',
        status: data.status || false
      };
    },
    errorMessage: 'Failed to fetch trading history',
    timeout: 15000,
    maxRetries: 2
  });
}; 